import Repository from './Repository';
import UserLogin from '@/models/User/UserLogin';
import UpdateUser from '@/models/User/UpdateUser';
import ChangePassword from '@/models/User/ChangePassword';
import { RequestResetPassword } from '@/models/User/RequestResetPassword';
import { ValidateResetPasswordToken } from '@/models/User/ValidateResetPasswordToken';
import { ResetPassword } from '@/models/User/ResetPassword';
import { ImpersonateUser } from '@/models/User/ImpersonateUser';
import UpdateLanguage from '@/models/User/UpdateLanguage';
import UpdateDatabase from '@/models/User/UpdateDatabase';
import ListRequest from '@/models/ListRequest';
import CreateAdminUser from '@/models/User/CreateAdminUser';
import UpdateAdminUser from '@/models/User/UpdateAdminUser';

const resource = '/users';

export default {
  fetchUserInfo(config?: any) {
    const cfg = Object.assign({ withCredentials: true }, config || {});
    return Repository.get(`${resource}/getloggedinuserdetails`, cfg);
  },
  login(user: UserLogin) {
    return Repository.post(`${resource}/login`, user, {withCredentials: true});
  },
  completeGoogleLogin(data: { code: string }) {
    return Repository.post(`/Users/CompleteGoogleLogin`, data, {withCredentials: true});
  },
  completeMicrosoftLogin(data: { code: string }) {
    return Repository.post(`/Users/CompleteMicrosoftLogin`, data, {withCredentials: true});
  },
  completeGoogleSignup(data: { code: string; signup: any }) {
    return Repository.post(`/Users/CompleteGoogleSignup`, data, {withCredentials: true});
  },
  verifyEmailMfaLogin(data: { email: string; code: string }) {
    return Repository.post(`/Users/VerifyEmailMfaLogin`, data, {withCredentials: true});
  },
  resendEmailMfaLogin(data: { email: string }) {
    return Repository.post(`/Users/ResendEmailMfaLogin`, data, {withCredentials: true});
  },
  logout() {
    return Repository.post(`${resource}/logout`, null, {withCredentials: true});
  },
  getUserProfile() {
    return Repository.get(`${resource}/getloggedinuserprofile`, {withCredentials: true});
  },
  updateUser(user: UpdateUser) {
    return Repository.post(`${resource}/updateuser`, user, {withCredentials: true});
  },
  updateEmailMfaSetting(data: { emailMfaEnabled: boolean }) {
    return Repository.post(`/Users/UpdateEmailMfaSetting`, data, {withCredentials: true});
  },
  changePassword(changePassword: ChangePassword) {
    return Repository.post(`${resource}/changepassword`, changePassword, {withCredentials: true});
  },
  requestResetPassword(requestResetPassword: RequestResetPassword) {
    return Repository.post(`${resource}/RequestResetPassword`, requestResetPassword);
  },
  validateResetPasswordToken(validateResetPasswordToken: ValidateResetPasswordToken) {
    return Repository.post(`${resource}/ValidateResetPasswordToken`, validateResetPasswordToken);
  },
  resetPassword(resetPassword: ResetPassword) {
    return Repository.post(`${resource}/ResetPassword`, resetPassword);
  },
  impersonateUser(impersonateUser: ImpersonateUser) {
    return Repository.post(`${resource}/ImpersonateUser`, impersonateUser, {withCredentials: true});
  },
  updateLanguage(language: UpdateLanguage) {
    return Repository.post(`${resource}/UpdateUserLanguage`, language, {withCredentials: true});
  },
  listAdminUsers(listRequest: ListRequest) {
    return Repository.post(`${resource}/ListAdminUsers`, listRequest, {withCredentials: true});
  },
  createAdminUser(createAdminUser: CreateAdminUser) {
    return Repository.post(`${resource}/CreateAdminUser`, createAdminUser, {withCredentials: true});
  },
  updateAdminUser(updateAdminUser: UpdateAdminUser) {
    return Repository.post(`${resource}/UpdateAdminUser`, updateAdminUser, {withCredentials: true});
  },
  deleteAdminUsers(ids: number[]) {
    return Repository.post(`${resource}/DeleteAdminUsers`, {ids: ids}, {withCredentials: true});
  },
};
